import React, { useMemo } from "react";
import { InspectionTypeMap, BOLMediaPurpose } from "../../utils/enums";
import Photo from "../Photo/Photo";
import PhotoFooter from "../PhotoFooter";

const Photos = ({ inspectionType, photos }) => {
  const photoGrid = useMemo(() => {
    const filtered = (photos || []).filter(
      photo => photo.purpose !== BOLMediaPurpose.Signatures,
    );

    return filtered.map(photo => (
      <div key={photo.url} className="photo-item">
        <Photo url={photo.url} />
        <PhotoFooter inspectionType={inspectionType} photo={photo} />
      </div>
    ));
  }, [inspectionType, photos]);

  return (
    <div className="section-container photos-section-print">
      <div className="section-header">{`${InspectionTypeMap[inspectionType]} Photos`}</div>
      <div className="photos-grid">{photoGrid}</div>
    </div>
  );
};

export default Photos;
